import React from "react";
import { Route } from "react-router";
import { Layout } from "./components/Layout";
import { Home } from "./components/Home";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import Footer from "./components/Footer";
import { PartnerError } from "./components/PartnerError";
import { NotAuthorized } from "./components/NotAuthorized";
import { Redirect } from "./components/Redirect";
import LegalNoticePopup from './components/LegalNoticePopup'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#711984",
    },
    text: {
      hint: "#d8d8d8",
    },
    error: {
      main: "#DB1829",
    },
  },
  shape: {
    borderRadius: 0,
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
        <Route exact path="/" component={Home} />
        <Route path="/partner-error" component={PartnerError} />
        <Route path="/not-authorized" component={NotAuthorized} />
        <Route path="/redirect" component={Redirect} />
      </Layout>
      <Footer />
    </ThemeProvider>
  );
};

export default App;
